import React from "react";

export default ({ color = "#FFF", grey = false }) => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M9.778,14.512 C9.778,15.064 9.33,15.512 8.778,15.512 C8.226,15.512 7.778,15.064 7.778,14.512 C7.778,13.96 8.226,13.512 8.778,13.512 C9.33,13.512 9.778,13.96 9.778,14.512 M5.778,5 C5.778,4.448 6.226,4 6.778,4 L12.488,4 C13.323,4 14,4.677 14,5.512 L14,8 C14,9.1 13.1,10 12,10 L10.509,10 C10.228,10 10,10.228 10,10.509 L10,11.512 C10,12.064 9.553,12.512 9,12.512 C8.448,12.512 8,12.064 8,11.512 L8,9.778 C8,8.796 8.796,8 9.778,8 L10.778,8 C11.33,8 11.778,7.552 11.778,7 C11.778,6.448 11.33,6 10.778,6 L6.778,6 C6.226,6 5.778,5.552 5.778,5 M17,18 L3,18 C2.448,18 2,17.552 2,17 L2,3 C2,2.448 2.448,2 3,2 L17,2 C17.553,2 18,2.448 18,3 L18,17 C18,17.552 17.553,18 17,18 M0,2 L0,18 C0,19.105 0.896,20 2,20 L18,20 C19.105,20 20,19.105 20,18 L20,2 C20,0.896 19.105,0 18,0 L2,0 C0.896,0 0,0.896 0,2"
        id="path-question"
      />
    </defs>
    <g
      id="Icon/20px/question-[#1445]"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <mask id="mask-question" fill="white">
        <use xlinkHref="#path-question" />
      </mask>
      <use fillOpacity={0} fill="#FFFFFF" xlinkHref="#path-question" />
      <g
        id="⚙️Atoms/Colour/Grey-Darker/1---100%"
        mask="url(#mask-question)"
        fill={grey ? "#CCCDD1" : color}
      >
        <g transform="translate(-1.000000, -1.000000)" id="Colour">
          <rect x={0} y={0} width={22} height={22} />
        </g>
      </g>
    </g>
  </svg>
);
